import { MessageSquareText, FileCheck2, Cog, Truck } from "lucide-react";

const steps = [
  {
    icon: MessageSquareText,
    step: "01",
    title: "Konsultasi & Kirim Desain",
    desc: "Hubungi kami via WhatsApp. Kirim logo/desain, jenis bahan, jumlah, dan posisi bordir yang Anda inginkan.",
  },
  {
    icon: FileCheck2,
    step: "02",
    title: "Approval Mockup",
    desc: "Tim kami siapkan mockup digital + file punching. Anda review, revisi jika perlu, lalu approve untuk produksi.",
  },
  {
    icon: Cog,
    step: "03",
    title: "Produksi Mesin Komputer",
    desc: "Order masuk slot mesin. Setiap unit melewati tahap QC sebelum dipacking — kami tidak kirim hasil yang gagal cek.",
  },
  {
    icon: Truck,
    step: "04",
    title: "Kirim ke Seluruh Indonesia",
    desc: "Kami kirim via marketplace terpercaya — transaksi aman, ada tracking real-time, dan dana baru lepas saat barang sampai.",
  },
];

export default function OrderingProcess() {
  return (
    <section
      id="proses"
      data-testid="process-section"
      className="py-20 md:py-28 bg-background"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
            Cara Pesan
          </span>
          <h2
            data-testid="process-headline"
            className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
          >
            Empat langkah, dari ide ke barang sampai.
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-muted-foreground leading-relaxed">
            Proses kami dirancang transparan. Anda tahu persis posisi pesanan
            Anda di setiap tahap — dari mana saja di Indonesia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, idx) => (
            <div
              key={idx}
              data-testid={`process-step-${idx}`}
              className="relative p-7 rounded-xl bg-secondary border border-border transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 rounded-lg bg-primary text-primary-foreground flex items-center justify-center">
                  <s.icon className="w-5 h-5" />
                </div>
                <span className="font-heading text-3xl font-bold text-primary/25">
                  {s.step}
                </span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground">
                {s.title}
              </h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-muted-foreground">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
